<!-- <div>isSafariUp--{{utilService.isSafari()}}</div>
<div>isMobile--{{utilService.isMobile()}}</div>
<div>isPwa--{{utilService.isPwa()}}</div>
<div>isIos--{{utilService.isiOS()}}</div>
<div>agent--{{navigator}}</div>
<div>platform--{{navPlatform}}</div>
<div>native app--{{appService.checkNativeApp()}}</div>
<div>showInstallBtn -- {{showInstallBtn}}</div> -->

<!-- <div id="login-bg-container" class="bg-screen container-fluid"
[style.backgroundImage]="utilService.getWidth() > 767 ? 'url('+ headerInfo.banner +')' : null">
<div class="kx-overlay">
  <div class="login-main-container">
    <div class="body-section">
      <div class="kx-left-section body-c"
        [style.backgroundImage]="utilService.isMobile() && utilService.getWidth() < 768 ? 'url('+ headerInfo.banner +')' : null">
        <div class="org-logo-wrapper" *ngIf="headerInfo.default_login_logo_needed">
          <img class="org-logo" [src]="headerInfo.login_logo">
        </div>
        <div class="message-container" *ngIf="headerInfo.default_tagline_needed">
          <span class="main-message top-msg-heading" [innerHtml]="headerInfo.login_tag"></span>
        </div>
        <div class="install-app-button noselect" (click)="installApp()" *ngIf="showInstallBtn">
          <div class="installbutton noselect">INSTALL LITE APP</div>
        </div>
        <div class="app-download-link-container"
          *ngIf="headerInfo != undefined && (headerInfo.android_app_given || headerInfo.ios_app_given)">
          <p class="text-white">Connect with us on mobile</p>

          <a *ngIf="headerInfo != undefined && headerInfo.android_app_given"
            [href]="headerInfo.android_app_url">
            <img class="mr-2" src="/assets/images/web-android-small.png">
          </a>
          <a *ngIf="headerInfo != undefined && headerInfo.ios_app_given" [href]="headerInfo.ios_app_url">
            <img src="/assets/images/web-ios-small.png">
          </a>
        </div>

      </div>
      <div class="kx-right-section body-c">
        <div class="login-content" *ngIf="!registerUser">
          <div class="login-content-top-section">
            <div class="top-heading">
              <p class="m-0">Sign-in</p>
            </div>
            <div class="language-sel">
              <dhs-langugage-selection (languageVal)="languageChange($event)">
              </dhs-langugage-selection>
            </div>
          </div>
          <div class="top-heading">
          </div>
          <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="mt-4" autocomplete="off">

            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0">
              <div class="floating-input-group c-mb-3">
                <input type="text" formControlName="login_id" class="form-control floating-input"
                  [ngClass]="{ 'is-invalid': submitted && f.login_id.errors }" minlength="2"
                  maxlength="50" [pattern]="checkPattern" autofocus required />
                <label for="login_id" class="floating-placeholder">{{'field.label.login_id' |
                translate | async }}</label>
                <div *ngIf="submitted && f.login_id.errors" class="invalid-feedback">
                  <div *ngIf="f.login_id.errors.required">
                  {{'required.login_id' | translate | async }}</div>
                  <div *ngIf="f.login_id.errors.minlength">
                  {{'validation.minlength.login_id' | translate | async }}</div>
                  <div *ngIf="f.login_id.errors.maxlength">
                  {{'validation.maxlength.login_id' | translate | async }}</div>
                  <div *ngIf="f.login_id.errors.pattern">
                  {{'validation.pattern.login_id' | translate | async }}</div>
                </div>
              </div>
            </div>

            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2 p-0">
              <div class="floating-input-group c-mb-3">
                <input type="{{eye != 'fa-eye'?'text':'password'}}" formControlName="password"
                  placeholder="" [ngClass]="{ 'is-invalid': submitted && f.password.errors }"
                  [pattern]="checkPattern" minlength="6" maxlength="20"
                  class="form-control floating-input" required />
                <label for="password" class="floating-placeholder">{{'field.label.password' |
                translate | async }}</label>
                <div class="input-group-append pass-eye-btn">
                  <div class="input-group-text pass-eye">
                    <span (click)="eye=(eye == 'fa-eye' ? 'fa-eye-slash':'fa-eye')">
                      <i class="fa {{eye}}"></i>
                    </span>
                  </div>
                </div>
                <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                  <div *ngIf="f.password.errors.required">
                    {{'required.password' | translate | async }}
                  </div>
                  <div *ngIf="f.password.errors.minlength">
                  {{'validation.minlength.password' | translate | async }}</div>
                  <div *ngIf="f.password.errors.maxlength">
                  {{'validation.maxlength.password' | translate | async }}</div>
                </div>
              </div>

            </div>

            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12  mb-2 p-0"
              *ngIf="isKarexpert=='karexpert'">
              <div class="floating-input-group">
                <input type="text" formControlName="account_url" class="form-control floating-input"
                  [ngClass]="{ 'is-invalid': submitted && f.account_url.errors }" minlength="2"
                  maxlength="255" pattern="^[a-zA-Z0-9&._@]+" required />
                <label for="account_url" class="floating-placeholder">Account Url</label>
                <div *ngIf="submitted && f.account_url.errors" class="invalid-feedback">
                  <div *ngIf="f.account_url.errors.required">Account Url is required</div>
                  <div *ngIf="f.account_url.errors.minlength">Account Url requied atleast 2
                    characters.
                  </div>
                  <div *ngIf="f.account_url.errors.maxlength">Account Url can not exceed 255
                    characters.
                  </div>
                  <div *ngIf="f.account_url.errors.pattern">Only Alphabet, hyphen, dot and numbers
                  are allowed.</div>
                </div>
              </div>
            </div>

            <div class="col-12 p-0 mt-4">
              <button class="login-button btn-gradient text-white">
                {{'button.label.login' | translate | async}} <i
              class="fa fa-angle-right login-btn-icon" aria-hidden="true"></i>
            </button>
          </div>
        </form>
        <div class="col-12 p-0 mt-2 login-form-links">
          <span class="cLink" (click)="forgotPassword()">Forgot Password</span>
        </div>

        <div class="col-12 p-0 mt-2 login-form-links" *ngIf="headerInfo.self_registration_needed">
          <span class="cLink" (click)="selfRegistration()">New Patient Registration</span>
        </div>
        <div class="col-12 p-0 mt-4" *ngIf="eulaList">
          <span (click)="showTnc()" class="border-bottom border-dark"
          style="cursor: pointer; font-size: 0.9em;">Terms of Service and Data Privacy Notice</span>
        </div>
        <div class="_wf-ft-maincontainer mt-5 mb-3">
          <div class="_wf-ft-leftcontent">
            <div class="_wf-ft-textcontent">Privacy</div>
            <div class="_wf-ft-textcontent">Terms &amp; conditions</div>
            <div class="_wf-ft-textcontent _wf-ft-noborder">Legal</div>
          </div>
          <div class="_wf-ft-textcontent _wf-ft-noborder">KareXpert © {{currentYear()}}</div>
        </div>
      </div>
      <div class="login-content" *ngIf="registerUser">
        <app-patient-registration (emitBackEvent)="backToLogin($event)"></app-patient-registration>
      </div>
    </div>
  </div>
</div>
</div>
</div> -->

@if (!config.isADredirect) {
  <div class="section">

    <div class="complince-container">
         <div class="complince-logo">          
          <div class="nabh-logo">
           @if (headerInfo.compliance_badge_nabh_his) {
            <img [src]="headerInfo.compliance_badge_nabh_his" loading="lazy" alt="" class="mr-2 cl-logo"
              onerror="this.onerror=null;">
            <div class="complince-label">NABH Certified<br>- Advanced HIS</div>
           }
          </div>

          <div class="nabh-logo">
             @if (headerInfo.compliance_badge_nabh_emr) {
            <img [src]="headerInfo.compliance_badge_nabh_emr" loading="lazy" alt="" class="mr-2 cl-logo"
              onerror="this.onerror=null;">
            <div class="complince-label">NABH Certified<br>- Advanced EMR</div>
             }
          </div>
          <div class="nabh-logo">
           @if (headerInfo.compliance_badge_abdm) {
            <img [src]="headerInfo.compliance_badge_abdm" loading="lazy" alt="" class="mr-2 cl-logo"
              onerror="this.onerror=null;">
          <div class="complince-label">ABDM Certified HIS  <br><span style="font-size: 12px;">(M1, M2 & M3)</span></div>
           }
          </div>
          <div class="nabh-logo">
           @if (headerInfo.compliance_badge_dpdp) {
            <img [src]="headerInfo.compliance_badge_dpdp" loading="lazy" alt="" class="mr-2 cl-logo"
              onerror="this.onerror=null;">
          <div class="complince-label"> DPDP Compliant</div>
           }
          </div>
        </div>
        </div>
    
    <!-- <div class="overlay-custom" style="display: none;">
    <div class="msg-section">
      <img src="/assets/images/filp-white.svg" >
      Please rotate your screen.
    </div>
  </div> -->
  <!--bg triangle-->
  @if (utilService.getWidth() > 1024) {
    <div class="bg-triangle"></div>
  }

  
  <!--bg triangle-->
  <!--web logo-->
  @if (utilService.getWidth() > 1024) {
    <div class="_wf-lp-logo-container">
      @if (headerInfo.showDefaultLogo) {
        <div class="_wf-lp-logo">
          <img class="image-35" src="/assets/images/Sample logo.png">
        </div>
      }
      @if (!headerInfo.showDefaultLogo) {
        <div class="_wf-lp-logo">
          <img class="image-35" [src]="headerInfo.login_logo">
        </div>
      }

      
      <!--super app-->
      <!-- <div *ngIf="superApps && superApps.length>1" id="super-app" class="dropdown header-dropdown dd-hover" data-toggle="dropdown" [triggered]="config.showSuperAppMenu"
      aria-haspopup="true" aria-expanded="false" (click)="config.showSuperAppMenu = !config.showSuperAppMenu;" >
      <div  class="super-app-icon-container">
        <i class="fa fa-th" aria-hidden="true"></i>
      </div>
      <div id="super-app-m-body" class="_menu-dropdown dropdown-menu dropdown-menu-right dropdown-menu-sm"
        style="top: 40px;display:block;" [hidden]="config.showSuperAppMenu == undefined || !config.showSuperAppMenu">
        <div class="dropdown-header">
          <strong>Select Application</strong>
        </div>
        <dhs-domain-platform [domainPlatformList]="appService._currentSessionData.superApps"></dhs-domain-platform>
      </div>
    </div> -->
  </div>
}
<!--web logo-->


<div class="_wf-lp-login-form-container">
  <img [src]="headerInfo.banner" alt="" class="image-36 mobile-v"
    onerror="this.onerror=null;this.src='/assets/images/login-BG.png';">
 <div class="d-flex complince-container-mb">
         <div class="complince-mb-logo ">
          <div class="nabh-logo">
            @if (headerInfo.compliance_badge_nabh_his) {
            <img [src]="headerInfo.compliance_badge_nabh_his" loading="lazy" alt="" class="mr-2 cl-logo"
              onerror="this.onerror=null;">
            <div class="complince-label"></div>
           }
          </div>
          <div class="nabh-logo">
          @if (headerInfo.compliance_badge_nabh_emr) {
            <img [src]="headerInfo.compliance_badge_nabh_emr" loading="lazy" alt="" class="mr-2 cl-logo"
              onerror="this.onerror=null;">
            <div class="complince-label"></div>
             }
            </div>
          <div class="nabh-logo">
           @if (headerInfo.compliance_badge_abdm) {
            <img [src]="headerInfo.compliance_badge_abdm" loading="lazy" alt="" class="mr-2 cl-logo"
              onerror="this.onerror=null;">
          <div class="complince-label"></div>
           }
          </div>
          <div class="nabh-logo">
           @if (headerInfo.compliance_badge_dpdp) {
            <img [src]="headerInfo.compliance_badge_dpdp" loading="lazy" alt="" class="mr-2 cl-logo"
              onerror="this.onerror=null;">
          <div class="complince-label"></div>
           }
          </div>
        </div>
        </div>

    <div class="_wf-lp-image-container">
      <img [src]="headerInfo.banner" loading="lazy" alt="" class="image-37 web-v"
        onerror="this.onerror=null;this.src='/assets/images/login-BG.png';">
        <!-- <div class="display_msg">{{headerInfo.name}} Healthcloud</div> -->
            

      </div>
      
      <div class="_wf-lp-whitebg">
        <div class="_wf-lp-login-form" [class.show]="loginservice.showLoginForm">
          <div class="login-overlay hide-after-1024px">
          </div>
          <div class="_wf-lp-form-block">
            <!-- (click)="showloginF.style.display = display" -->
            @if (utilService.isMobile()) {
              <div class="close-btn-form" (click)="loginservice.showLoginForm = false">
                <i class="fa fa-times-circle"></i>
              </div>
            }
            @if (adService.adObj.adConfigs.length>0 && !config.loginWithOther) {
              <div class="_form-section">
                <div class="language-sel">
                  <dhs-langugage-selection [languageList]="appService._currentSessionData.languageList"
                    (languageVal)="languageChange($event)">
                </dhs-langugage-selection>
              </div>
              <div class="_image-section">
                <div class="_image-div">
                  @if (config.isPatient == true) {
                    <img src="assets/images/ha_patients.png"
                      alt="patient image">
                  }
                  @if (config.isPatient == false) {
                    <img src="assets/images/ha_doctors_.png"
                      alt="care provider image">
                  }
                </div>
              </div>
              <div class="_form-action-section">
                <div class="_checkbox-section">
                  <div class="checkbox-container">
                    <label class="check-wrapper">
                      <p class="truncate-text">{{'Patient' | translate | async }} </p>
                      <input [(ngModel)]="config.isPatient" type="radio" class="radio"
                        name="patientRadio" [value]="true">
                      <span class="check-mark"></span>
                    </label>
                  </div>
                  <div class="checkbox-container">
                    <label class="check-wrapper">
                      <p class="truncate-text">{{'care_pro' | translate | async }} </p>
                      <input [(ngModel)]="config.isPatient" type="radio" class="radio"
                        name="patientRadio" [value]="false">
                      <span class="check-mark"></span>
                    </label>
                  </div>
                </div>
                <div class="col-12 p-0 mt-2">
                  <button type="button" [disabled]="adService.adObj.disabled"
                    (click)="redirectToADLogin(adService.adObj.adConfigs[0].type)"
                    class="login-button btn-gradient button-hover text-white">
                    {{'logasemp' | translate | async }} <i class="fa fa-angle-right lg-btn-icon"
                  aria-hidden="true"></i>
                </button>
              </div>
              <div class="col-12 p-0 mt-3">
                <button (click)="removeAdObj();config.loginWithOther = true"
                  class="login-button btn-gradient button-hover text-white">
                  {{'logasoth' | translate | async }} <i class="fa fa-angle-right lg-btn-icon"
                aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </div>
      }
      @if (adService.adObj.adConfigs.length == 0 || config.loginWithOther) {
        @if (!registerUser && !logInWithMobile && !mfa && !checkurl()) {
          <div class="mb-4">
            <div class="login-content-top-section">
              @if (adService.adObj.adConfigs.length > 0 && config.loginWithOther) {
                <div class="landing-form-back-button-container"
                  >
                  <a class="" href="javascript:void(0)" (click)="config.loginWithOther = false;">
                    <img src="assets/images/grid-back.png">
                  </a>
                </div>
              }
              <div class="top-heading landing-form-heading">
                <p class="m-0">{{'field.label.sign_in' | translate | async }}</p>
              </div>
              <div class="language-sel">
                <dhs-langugage-selection
                  [languageList]="appService._currentSessionData.languageList"
                  (languageVal)="languageChange($event)">
                </dhs-langugage-selection>
              </div>
            </div>
            <div class="top-heading">
            </div>
            <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="mt-3" autocomplete="off">
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0">
                <div class="floating-input-group c-mb-3">
                  <ng-template #errorTemplate>
                    <div>
                      @if (f.login_id.errors.required) {
                        <div>
                        {{'required.login_id' | translate | async }}</div>
                      }
                      @if (f.login_id.errors.minlength) {
                        <div>
                        Login Id cannot be less than 2 Character.</div>
                      }
                      @if (f.login_id.errors.maxlength) {
                        <div>
                        {{'validation.maxlength.login_id' | translate | async }}</div>
                      }
                      @if (f.login_id.errors.pattern) {
                        <div>
                        {{'validation.pattern' | translate | async }}</div>
                      }
                    </div>
                  </ng-template>
                  <input type="text" formControlName="login_id"
                    class="form-control floating-input"
                    [ngClass]="{ 'is-invalid': submitted && f.login_id.errors }" minlength="2"
                    maxlength="50" autofocus required [placeholder]="login_id_placeholder" />
                  <label for="login_id" class="floating-placeholder">{{'field.label.login_id' |
                  translate | async }}</label>
                  @if (submitted && f.login_id.errors) {
                    <div class="input-detail-error form-v2"
                      [popover]="errorTemplate" triggers="mouseenter:mouseleave">
                      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                    </div>
                  }
                </div>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2 p-0">
                <div class="floating-input-group c-mb-3 has-icon">
                  <ng-template #errorTemplate2>
                    <div>
                      @if (f.password.errors.required) {
                        <div>
                          {{'required.password' | translate | async }}
                        </div>
                      }
                      @if (f.password.errors.minlength) {
                        <div>
                        {{'validation.minlength.password' | translate | async }}</div>
                      }
                      @if (f.password.errors.maxlength) {
                        <div>
                        {{'validation.maxlength.password' | translate | async }}</div>
                      }
                      @if (f.password.errors.pattern) {
                        <div>
                        {{'validation.pattern' | translate | async }}</div>
                      }
                    </div>
                  </ng-template>
                  <input type="{{eye != 'fa-eye'?'text':'password'}}" formControlName="password"
                    [placeholder]="password_placeholder" autocomplete="off" placeholder=""
                    [ngClass]="{ 'is-invalid': submitted && f.password.errors }" minlength="6"
                    maxlength="20" class="form-control floating-input" required />
                  <label for="password" class="floating-placeholder">{{'field.label.password' |
                  translate | async }}</label>
                  @if (submitted && f.password.errors) {
                    <div class="input-detail-error form-v2"
                      [popover]="errorTemplate2" triggers="mouseenter:mouseleave">
                      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                    </div>
                  }
                  <div class="input-group-append pass-eye-btn">
                    <div class="input-group-text pass-eye">
                      <span (click)="eye=(eye == 'fa-eye' ? 'fa-eye-slash':'fa-eye')">
                        <i class="fa {{eye}}"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              @if (isKarexpert=='karexpert') {
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12  mb-2 p-0"
                  >
                  <div class="floating-input-group">
                    <ng-template #errorTemplate3>
                      <div>
                        @if (f.account_url.errors.required) {
                          <div>
                          {{'required.account_id' | translate | async }}</div>
                        }
                        @if (f.account_url.errors.minlength) {
                          <div>
                            {{'field.label.account_Url_required' | translate | async }}
                          </div>
                        }
                        @if (f.account_url.errors.maxlength) {
                          <div>
                            {{'field.label.account_Url_not_exceed' | translate | async }}
                          </div>
                        }
                        @if (f.account_url.errors.pattern) {
                          <div>
                            {{'field.label.only_alphabet_hyphen_dot_numbers' | translate | async
                            }}
                          </div>
                        }
                      </div>
                    </ng-template>
                    <input type="text" formControlName="account_url"
                      class="form-control floating-input"
                      [ngClass]="{ 'is-invalid': submitted && f.account_url.errors }"
                      minlength="2" maxlength="255" pattern="^[a-zA-Z0-9&._@]+" required />
                    <label for="account_url"
                      class="floating-placeholder">{{'field.label.account_url' | translate | async
                    }}</label>
                    @if (submitted && f.account_url.errors) {
                      <div
                        class="input-detail-error form-v2" [popover]="errorTemplate3"
                        triggers="mouseenter:mouseleave">
                        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                      </div>
                    }
                  </div>
                </div>
              }
              @if (show_captcha && this.headerInfo.additional_authentication_required) {
              <div class="captcha-generate">
                <div>
                  <dhs-form-question [question]="loginForm.controls.captcha.question" [validIn]="submitted && f.captcha.errors" [form]="loginForm">
                   </dhs-form-question>
                </div>
              </div>
              }
              <!-- <p *ngIf="!isCapsLockOn" style="color: red;"> Warning: Caps Lock is ON </p> -->
              <div class="col-12 p-0 mt-4">
                <button class="login-button btn-gradient button-hover text-white">
                  {{'button.label.login' | translate | async}} <i
                class="fa fa-angle-right lg-btn-icon" aria-hidden="true"></i>
              </button>
            </div>
          </form>
          <!-- <div class="terms-cstm"> -->
          <!-- <div class="" *ngIf="eulaList">
          <span (click)="showTnc()" class="border-bottom border-dark"
          style="cursor: pointer; font-size: 0.9em;">{{'field.label.terms_of_service' | translate | async }}</span>
        </div> -->
        @if (!headerInfo.loginwith_pin_not_req){
          <div class="login-options-container">
            <div class="divider">
              <span>{{'Or' | translate | async }}</span>
            </div>
            @if (!checkurl()) {
            <div class="button-group">
              <button class="login-btn"
                (click)="logInMobile();loginservice.showLoginForm = true">{{'field.label.patient_login_with_mobile'
                | translate | async }}</button>
              <button class="login-btn" (click)="logInPin();loginservice.showLoginForm = true">{{'field.label.login_with_pin'
                | translate | async }}</button>
            </div>
            }
            <span class="forgot-password" (click)="forgotPassword()">{{'field.label.forgot_password' |
              translate | async }}</span>
          </div>
        }
        @if (headerInfo.loginwith_pin_not_req){
          <div class="login-form-links mt-1 forgot-pass-login">
            <span class="cLink" (click)="forgotPassword()">{{'field.label.forgot_password' |
              translate | async }}</span>
          </div>
          @if (!checkurl()) {
          <div class="login-form-links mt-1 login-form-links">
            <span class="cLink"
              (click)="logInMobile();loginservice.showLoginForm = true">{{'field.label.patient_login_with_mobile'
              | translate | async }}</span>
          </div>
          }
        }
      <!-- <div class="col-12 p-0 mt-2 login-form-links" *ngIf="headerInfo.self_registration_needed">
      <span class="cLink" (click)="selfRegistration()">New Patient Registration</span>
    </div> -->
    <!-- <div class="_wf-ft-maincontainer mt-5 mb-3">
    <div class="_wf-ft-leftcontent">
      <div class="_wf-ft-textcontent">Privacy</div>
      <div class="_wf-ft-textcontent">Terms &amp; conditions</div>
      <div class="_wf-ft-textcontent _wf-ft-noborder">Legal</div>
    </div>
    <div class="_wf-ft-textcontent _wf-ft-noborder">KareXpert © {{currentYear()}}</div>
  </div> -->
</div>
}
@if (registerUser) {
  <div class="mb-4">
    <app-patient-registration [config]="registerConfig"
    (emitBackEvent)="backToLogin($event)"></app-patient-registration>
  </div>
}
@if (checkurl() && !registerUser) {
  <div class="mb-4">
    <app-login-mobile-no [logInWith]='logInWith' (emitBackEvent)="backToLogin($event)"></app-login-mobile-no>
  </div>
}
@if (mfa) {
  <div class="mb-4">
    <div class="login-with-mobile-screen form-top-section">
      <div class="landing-form-back-button-container">
        <a class="" href="javascript:void(0)" (click)="back()">
          <img src="assets/images/grid-back.png">
        </a>
      </div>
      <div class="landing-form-heading">
        <div class="">
          {{'field.label.sign_in' | translate | async }}
        </div>
      </div>
      <div class="language-sel">
        <dhs-langugage-selection
          [languageList]="appService._currentSessionData.languageList"
          (languageVal)="languageChange($event)">
        </dhs-langugage-selection>
      </div>
    </div>
    <div class="mt-2">
      @if (mfa == 'pin') {
        <p>{{ 'field.label.Enter_4_digit_pin' | translate | async }}</p>
      }
      @if (mfa != 'pin') {
        <p>{{ 'field.label.Enter_otp' | translate | async }}</p>
      }
    </div>
    <app-otp-input #ngOtpInput (onInputChange)="onOtpChange($event)" [config]="mfaConfig">
    </app-otp-input>
    <div class="col-12 p-0 mt-4">
      <button class="login-button btn-gradient button-hover text-white" [disabled]="!otp"
        (click)="onSubmit()">
        {{'button.validate' | translate | async}} <i class="fa fa-angle-right lg-btn-icon"
      aria-hidden="true"></i>
    </button>
  </div>
  @if (mfa != 'pin') {
    <div class="col-12 mt-1 p-0">
      @if (!showTimer) {
        <span class="cLink" (click)="resendOTP()">{{'field.label.resend_OTP'
        | translate | async }}</span>
      }
      @if (showTimer) {
        <span class="timer" style="cursor: not-allowed; color: gray;">
          {{'field.label.resend_OTP_in_timer_sec' | translate | async }} {{timer}}
          {{'field.label.seconds' | translate | async}}
        </span>
      }
    </div>
  }
  @if (mfa == 'pin') {
    <div class="login-form-links mt-1 login-form-links">
      <span class="cLink" (click)="generatePin()">{{'field.label.generate_pin' | translate |
      async }}</span>
    </div>
  }
</div>
}
<div class="_wf-lp-signup-container">
  <!-- <div class="d-flex w-100 align-items-center justify-content-between">
  <div class="text-block-369">{{'field.label.new_to_the_platform' | translate | async }}</div>
  <div class="_wf-lp-signup-btn" (click)="selfRegistration()">
    <div class="text-block-370">{{'field.label.sign_up' | translate | async }}</div>
  </div>
</div> -->
<!--branding mobile-->
@if (headerInfo.onl_ip_pay) {
  <div class="registration-button-container button-hover"
    (click)="onlinePayment()">
    {{'field.label.online_payment' | translate | async }}
  </div>
}
@if (!registerUser && headerInfo.self_registration_needed && !checkKioskSelfRegister()) {
  <div class="registration-button-container button-hover mt-2" (click)="selfRegistration()"
    >
    {{'field.label.click_hare_for_new_user_registration' | translate | async }}
    <!-- Register New User -->
  </div>
}
<!--branding mobile-->
@if (utilService.isMobile()) {
  <div class="_wf-lp-logo-footer-main _wf-lp-mobile-footer">
    <div class="_wf-lp-img-block">
      <div class="_wf-lp-footer-logo"><img src="assets/images/logo-powered-white.svg"
      loading="lazy" alt=""></div>
    </div>
  </div>
}
<!--terms & condition-->
@if (!registerUser) {
  <div class="terms-and-condition-container">
    <!-- <div class="" *ngIf="eulaList"> -->
    <div class="d-flex">
      <span (click)="showTnc('User Manual')"
        style="cursor: pointer; font-size: .95em;" class="user_manual"> *{{'field.label.user_manual' |
      translate | async }}</span>
      <span>&nbsp;|&nbsp;</span>
      <span (click)="showTnc()"
        style="cursor: pointer; font-size: .95em;" class="terms_n_condition"> {{'field.label.terms_of_service' |
      translate | async }}</span>
    </div>
  </div>
}
</div>
}
</div>
</div>
<div class="_wf-lp-logo-footer-main">
  <div class="_wf-lp-footer-logo"><img src="assets/images/logo-powered-white.svg" loading="lazy"></div>
</div>
</div>

<div class="_register-login-btn">
  <!-- mobile login button -->
  <div (click)="loginBack()">
    <div class="_wf-lp-signinbtn" (click)="loginservice.showLoginForm = true">
      <div class="text-block-376">{{'field.label.sign_in' | translate | async}}</div>
    </div>
  </div>
  <div class="signin-sc-btn">
  <!-- mobile reg button -->
  @if (headerInfo.self_registration_needed && !checkKioskSelfRegister()) {
    <div (click)="selfRegistration()">
      <div class="_wf-lp-signinbtn" (click)="loginservice.showLoginForm = true">
         <div class="text-block-376">
          {{'field.label.new_user_registration' | translate | async}}
          <!-- Register New User -->
        </div>
      </div>
    </div>
  }

<!-- mobile install lite app button -->
  @if (isAppStatusChecked && showInstallBtn) {
    <div class="_wf-lp-signinbtn" (click)="installApp()">
      <div class="text-block-376">{{'field.label.install_lite_app' | translate | async }}</div>
    </div>
  }

  </div>

  @if (headerInfo.onl_ip_pay) {
    <div (click)="onlinePayment()">
      <div class="_wf-lp-signinbtn" (click)="loginservice.showLoginForm = true">
        <div class="text-block-376">
          {{'field.label.online_payment' | translate | async }}
        </div>
      </div>
    </div>
  }
  <!-- mobile check status button -->
  @if (!isAppStatusChecked) {
    <div class="_wf-lp-signinbtn">
      <div class="text-block-376">{{'field.label.check_app_status' | translate | async}}</div>
      <div class="spinner-border text-primary ml-2"></div>
    </div>
  }
  
</div>
</div>

</div>


}
@if (config.isADredirect) {
  <div class="load_bg">
    <span class="load_img">
      <img src="/assets/images/6722-loading.gif" class="org-logo">
      <span>Loading...</span>
    </span>
  </div>
}
<div dhs-modal></div>

